const pluralRules = new Intl.PluralRules('en-US');

const irregularPlurals = {
  reply: 'replies',
};

export const getPluralForm = (count, word) => {
  const pluralCategory = pluralRules.select(count);
  if (count === 0 || pluralCategory === 'other') {
    const plural = irregularPlurals[word] || `${word}s`;
    return `${count} ${plural}`;
  } else if (count === 1) {
    return `1 ${word}`;
  } else {
    const plural = irregularPlurals[word] || `${word}s`;
    return `${count} ${plural}`;
  }
};

// export const abbreviateNumber = (value) => {
//   value = Math.round(value); 
//   if (value === 0) return "0"; 

//   const SI_SYMBOL = ["", "K", "M", "G", "T", "P", "E"];
//   const tier = Math.floor(Math.log10(Math.abs(value)) / 3);

//   if (tier === 0) return value.toString(); 

//   const suffix = SI_SYMBOL[tier]; 
//   const scale = Math.pow(10, tier * 3); 
//   const scaled = value / scale; 

//   if (tier === 1 && value >= 1000 && value < 10000) {
//     return scaled.toFixed(1).replace('.', ',') + suffix; 
//   }
  
//   if (tier >= 1) {   
//     if (tier >= 2) {
//       return scaled.toFixed(3).replace('.', ',') + suffix; 
//     }
    
//     return scaled.toFixed(2).replace('.', ',') + suffix; 
//   }

//   return scaled.toFixed().replace('.', ',') + suffix; 
// };

export const abbreviateNumber = (value, formatType) => {
  value = Math.round(value);

  if (formatType === "badge") {
    return value.toLocaleString("en").replace(/\./g, ",");
  }

  if (formatType === "short") {    
    if (value >= 1000000) {
      // Для миллионов
      return (value / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    } else if (value >= 10000) {
      // Для чисел от 10,000 до 999,999
      return (value / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
    } else {
      // Для чисел меньше 10,000
      return value.toLocaleString("en");
    }
  }

  return value.toString();
};

// export const formatRating = (rating) => {
//   if (rating >= 1000000) {
//     return (Math.round((rating / 100000) * 10) / 100).toFixed(1).replace(/\.0$/, '') + 'M';
//   } else if (rating > 99000) {
//     return Math.floor(rating / 1000).replace(/\.0$/, '') + 'K';
//   } else if (rating >= 1000) {
//     return (Math.round((rating / 100) * 10) / 100).toFixed(1).replace(/\.0$/, '') + 'K';
//   } else {
//     return rating.toString();
//   }
// };

export const calcPercenteChange = (prev, cur) => {
  return prev !== 0 ? ((cur - prev) / prev) * 100 : 0;
}

